"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Highimpactconversioncta() {
  const {
    ref: word1Ref,
    isVisible: word1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word2Ref,
    isVisible: word2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word3Ref,
    isVisible: word3Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3501" id="highimpactconversioncta" className="relative bg-background text-foreground overflow-hidden py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-20">
      <div className="absolute bottom-0 left-0 w-full h-1 bg-accent/20" aria-hidden="true" />
      {}
      <div className="hidden md:block absolute left-6 top-1/2 -translate-y-1/2 z-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] block drop-shadow-[0_0_8px_var(--primary)]" style={{
        color: "var(--primary)",
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          TIMEARRIVAL — OPTIMIZACIÓN
        </span>
      </div>

      {}
      <div className="hidden md:block absolute right-0 top-0 bottom-0 w-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 8px var(--primary)"
    }} aria-hidden="true" />

      {}
      <div className="md:hidden absolute left-0 right-0 top-0 h-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 4px var(--primary)"
    }} aria-hidden="true" />

      <div className="relative max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-7 lg:col-start-1">
            <h2 className="font-default font-extrabold uppercase leading-[0.9] text-foreground text-[56px] sm:text-[80px] md:text-[110px] lg:text-[140px] mb-4 md:mb-6" style={{
            letterSpacing: "0.01em"
          }}>
              <span ref={word1Ref} data-index={0} className="block transition-all duration-700 ease-out !text-5xl" style={{
              opacity: word1Visible ? 1 : 0,
              transform: word1Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "0ms"
            }}>CONVIERTA CADA LLEGADA EN UNA OPORTUNIDAD PARA MEJORAR LA EXPERIENCIA DEL HUÉSPED</span>
              
              
            </h2>
          </div>

          {}
          <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
            <div ref={cardRef} className="w-full lg:max-w-[440px] p-8 md:p-10 border-l-4 border-l-primary border border-border backdrop-blur-sm transition-all duration-700 ease-out shadow-2xl" style={{
            backgroundColor: "var(--card)",
            opacity: cardVisible ? 1 : 0,
            transform: cardVisible ? "translateX(0)" : "translateX(40px)",
            transitionDelay: "600ms"
          }}>
              {}
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] mb-4 md:mb-6" style={{
              color: "var(--primary)"
            }}>
                DEMOSTRACIÓN GRATUITA
              </div>

              {}
              <p className="font-default font-light text-base md:text-lg leading-relaxed text-foreground/90 mb-4 md:mb-6">Transforma la experiencia de tus huéspedes con seguimiento en tiempo real. Reduce esperas y mejora la eficiencia operativa hoy mismo.</p>

              {}
              <Button className="w-full h-14 uppercase font-default font-bold text-sm tracking-[0.15em] shadow-lg bg-primary text-primary-foreground hover:scale-105 active:scale-95 transition-all duration-200 mt-4 md:mt-6" onClick={() => window.location.href = "/BookDemoPage"}>SOLICITAR PRESENTACION<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 size-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Highimpactconversioncta.tsx|sig:r623bl" data-ast-start="4077" data-ast-end="4115"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Button>

              {}
              
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}